import { Fragment,useState } from 'react'
import logo from './logo.svg';
import './App.css';
import Menu from './componentMenu.tsx'; 
import Welcome from './componentWelcome.tsx'; 
import ROIEditor from './componentRegionOfInterest.tsx'; 
import Reports from './componentReports.tsx'; 
import Status from './componentStatus.tsx'; 
import Console from './componentConsole.tsx';
function App() {
    /*shared state to sync menu and body*/
    const [tab, setTab] =useState("start");

    
    
    
  return (
	  <div className="App">
	  <div aria-describedby="cookieconsent:desc" aria-label="cookieconsent-dialog" aria-live="polite" className="cc-window cc-bottom-right cc-type-opt-in cc-theme-basic cc-hide" id="cookieconsent:window" role="dialog">
	  <div className="cc-body" id="cookieconsent:body">
    <span className="cc-message" id="cookieconsent:desc">
        
    
        Diese Webseite verwendet Cookies, um die Bedienfreundlichkeit zu erhöhen.
    


    <a aria-label="Weitere Informationen zu unseren verwendeten Cookies" className="cc-link" href="https://martin.bgd.ed.tum.de/rsa/datenschutz/#AktiveKomponenten" rel="noopener noreferrer nofollow" target="_blank">
        Weitere Informationen
    </a>



        
    <div className="dp--cookie-check" >
    <label htmlFor="dp--cookie-required">
        <input className="dp--check-box" id="dp--cookie-required" tabIndex="-1" type="checkbox" name="" value="" defaultChecked  disabled=""/>
        Notwendig
    </label>
    <label htmlFor="dp--cookie-statistics">
        <input className="dp--check-box" id="dp--cookie-statistics" tabIndex="1" type="checkbox" name="" value=""/>
        Statistiken
    </label>
		
</div>


    </span>
    <div className="cc-compliance cc-highlight">
        <button className="cc-btn cc-allow-all cc-w-100" aria-label="Alle Cookies zulassen">
    Alle akzeptieren!
</button>

        <button className="cc-btn cc-allow">
    Speichern
</button>

        <button className="cc-btn cc-deny" aria-label="Nur notwendige Cookies zulassen">
    notwendige <span></span>Cookies
</button>

    </div>
    <div className="powered-by">Powered by <a href="https://dp-wired.de/?ref=consent-note" rel="noopener" target="_blank">DP Wired</a></div>
</div></div>


<header>
    

<div id="topbar" className="c-topbar py-1">
	<div className="container">
		<a className="c-skiplink" id="skipnav" href="https://martin.bgd.ed.tum.de/design.html#content" title="Zum Inhalt springen" aria-label="Zum Inhalt springen">
			Zum Inhalt springen
		</a>

        <div className="d-flex justify-content-md-end justify-content-between">

            <div className="d-flex">

                

                
                
                
                    
                        
                    
                
                    
                        
                    
                

                
                    <div className="c-languagenav">
                        
                                    <ul className="list-inline  c-languagenav__list">
                                        
                                            
                                            
                                            <li className="list-inline-item  c-languagenav__item">
                                                
                                                        <strong>
                                                            <abbr lang="de" title="Deutsch">de</abbr>
                                                        </strong>
                                                    
                                            </li>
                                            
                                        
                                            
                                            
                                            <li className="list-inline-item  c-languagenav__item">
                                                
                                                        
                                                                <a className="c-languagenav__link" href="https://martin.bgd.ed.tum.de/en/rsa/home/" hrefLang="en-US">
                                                                    <abbr lang="en" title="English">en</abbr>
                                                                </a>
                                                            
                                                    
                                            </li>
                                            
                                        
                                    </ul>
                                
                    </div>
                

                
                    
                        
                    
                

            </div>

            <div className="d-md-none">
                <button id="menutoggle" className="c-menu-mobile navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#sitenav" aria-expanded="false" title="Navigation öffnen" aria-label="Navigation öffnen">
                    <span className="navbar-toggler-icon"></span>
                    <span className="c-menu-mobile__text">Menü</span>
                </button>
            </div>

            

            <template id="global-search-popup"></template>

        </div>

	</div>
</div>

    
		
<div className="c-siteorg ">
    <div className="container c-siteorg__grid">
        
      <div className="nav clearfix">
	
            <ul className="c-siteorg__list">
              <li className="l_this">
                        <a href="https://martin.bgd.ed.tum.de/en/" title="Landing Page Big Geospatial Data Management">
                            Professur Big Geospatial Data Management
                        </a>
                    </li>

                    <li className="l_parent">
                        <a href="https://www.ed.tum.de/" title="Startseite TUM School of Engineering and Design">
                            TUM School of Engineering and Design
                        </a>
                    </li>
                

                
                    <li className="l_top">
                        <a href="https://www.tum.de/" title="Startseite Technische Universität München">
                            Technische Universität München
                        </a>
                    </li>
                
            </ul>

	    
        </div>
        <div>
            <a href="https://www.tum.de/" title="Startseite www.tum.de">
                <img src="./assets/template_files/tum-logo.png" alt="Technische Universität München"/>
            </a>
        </div>
    </div>
</div>


</header>

    <main id="page-body">
        <div className="container  c-content-area">

            <div className="row">

                <div className="col-md-3 col-xl-2  c-content-area__sitenav">
                    

<div className="c-sitenav navbar navbar-expand-md">
    <div id="sitenav" className="collapse navbar-collapse">
        <nav className="sitemenu c-sitenav__wrapper" aria-label="Hauptnavigation">
	  <Menu navigator={(x)=>{setTab(x);}}/>
        </nav>
    </div>
</div>






                </div>

                <div className="col-md-6 col-xl-8  c-content-area__main js-link-checker">
                    




                    
                    
<div id="content" className="c-main">

					<div id="c21318" className="frame 
 frame-type-textmedia frame-layout-0">

      { (tab=="start" && <Welcome/>)}
      { (tab=="reports" && <Reports/>)}
      { (tab=="regions" && <ROIEditor/>)}
      { (tab=="status" && <Status/>)}
      { (tab=="console" && <Console/>)}
      
      

	</div>

				
		
	






	

			

					<div id="c21319" className="frame 
 frame-type-textmedia frame-layout-0">
                        
                        
    
    
    
            
                            
                            
                            
                            
                                



                            
                            
	


		
				
			


	
				

    



	


                            
    
    

    
            
                                

	
			
			
			

			
					
				

			<div className="ce-textpic ce-center ce-above">

				
					

	<div className="ce-gallery   ce-gallery-full" data-ce-columns="1" data-ce-images="1">
		
			<div className="ce-outer">
				<div className="ce-inner">
				</div>
			</div>
		
	</div>
			</div>
					</div>
</div>

<div className="c-link-to-top  js-link-to-top">
	<a href="https://martin.bgd.ed.tum.de/design.html#topbar" title="nach oben springen">
		To top
	</a>
</div>



                </div>

                <div className="col-md-3 col-xl-2  c-content-area__aside js-link-checker">
                    
                    

<div id="sidebar" className="sidebar">
	<aside className="c-aside">
		

	

			

					<div id="c21290" className="frame 
 frame-type-textmedia frame-layout-0">
                        
                        
    
    
    
            
                            
                            
                            
                            
                                



                            
                            
	


		
				
			


	
				

    
				

	
			
	
			<h2>
				OSM Road Monitor
			</h2>
		

		<p><strong>Professur für Big Geospatial Data Management</strong></p>
<p>Lise-Meitner-Str. 9<br/> 85521 Ottobrunn</p>
<p>Tel.: +49 89 289 555 50</p>
<p>Mail: <a href="mailto:office.bgd@ed.tum.de">office.bgd@ed.tum.de</a></p>
					</div>

	</aside>
</div>



                </div>

            </div>

        </div>
    
                <dialog id="global-search-overlay" className="c-global-search-overlay js-gsc-dialog px-5 py-4 bg-body shadow" aria-labelledby="global-search-popup-title" aria-describedby="global-search-popup-desc">
                    <h2 id="global-search-popup-title" className="fs-1 border-0">Google Custom Search</h2>
                    <p id="global-search-popup-desc">
                        Wir verwenden Google für unsere Suche. Mit Klick auf „Suche aktivieren“ aktivieren Sie das Suchfeld und akzeptieren die Nutzungsbedingungen.
                    </p>
                    <p>
                        <a href="https://martin.bgd.ed.tum.de/rsa/datenschutz/#GoogleCustomSearch" title="Datenschutz">
                            Hinweise zum Einsatz der Google Suche
                        </a>
                    </p>
                    <form method="dialog">
                        <button className="btn btn-primary c-global-search__button c-global-search__accept js-search-activate js-search-close" type="button">
                            Suche aktivieren
                        </button>
                        <button className="btn-close position-absolute top-0 end-0 p-2 js-search-close" type="button" aria-label="Popup schliessen">
                        </button>
                    </form>
                </dialog>
            </main>



	<footer className="c-footer">

        <div className="c-footer__legal">
            <nav className="container" aria-label="legal links">
                <ul className="list-inline"><li className="list-inline-item"><a href="https://martin.bgd.ed.tum.de/rsa/datenschutz/">Datenschutz</a></li><li className="list-inline-item"><a href="https://martin.bgd.ed.tum.de/rsa/impressum/">Impressum</a></li><li className="list-inline-item"><a href="https://martin.bgd.ed.tum.de/rsa/erklaerung-barrierefreiheit/">Barrierefreiheit</a></li></ul>
            </nav>
        </div>

        

	</footer>

      
	 
    </div>
  );
}

export default App;
